import { baseClient } from './client/instance';

export type WhatsAppQRResponse = {
  status: 'qr' | 'connecting' | 'open' | 'closed' | 'none';
  qr: string | null;
  phone: string | null;
};

export type WhatsAppStatusResponse = {
  status: string;
  phone: string | null;
};

/** Initiate a WhatsApp QR session. Returns the first QR code if available. */
export const startWhatsAppSession = async (): Promise<WhatsAppQRResponse> => {
  const response = await baseClient.post<WhatsAppQRResponse>('/auth/whatsapp');
  return response.data;
};

/** Poll for the latest QR code or connection status. */
export const getWhatsAppQR = async (): Promise<WhatsAppQRResponse> => {
  const response = await baseClient.get<WhatsAppQRResponse>('/auth/whatsapp/qr');
  return response.data;
};

/** Get current connection status (without starting a new session). */
export const getWhatsAppStatus = async (): Promise<WhatsAppStatusResponse> => {
  const response = await baseClient.get<WhatsAppStatusResponse>('/auth/whatsapp/status');
  return response.data;
};
